var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groupsDetail"},[_c('ps-groups-detail-upper-bar',{attrs:{"site":{ site: 'Nuevo grupo' },"icon":"el-icon-edit"},on:{"clickIcon":_vm.editProfile}}),_c('div',{staticClass:"container"},[(_vm.editionMode == true)?_c('ps-groups-detail-header'):_vm._e(),(_vm.$route.params['groupId'] > 0)?_c('ps-groups-detail-daily'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }